module.exports = __webpack_public_path__ + "img/yml_gallery4.02b92603.jpg";